/**
 * Shared sf_member helpers — the matching/compute logic behind the
 * "existing-member / XP post-reg offer" discount-code price override
 * (shop metafield custom.sf_member_discount_codes). Extracted so new call
 * sites (e.g. shop-all/collection cards) don't become a 6th inline copy of
 * what's otherwise duplicated per-section on PDP (safe-kids-product.liquid,
 * safe-kids-tracker-product-v2.liquid, safe-pets-tracker-product-v2.liquid,
 * safe-seniors-tracker-product-v2.liquid) and the member banner sections.
 *
 * Those 5 existing sections are NOT refactored to use this file — they
 * already work and verifying a refactor byte-for-byte across 5 live pricing
 * surfaces is a separate, carefully-isolated change. This file exists so the
 * 6th (and any future) call site has somewhere to call into instead of
 * copy-pasting a 6th time.
 */
(function (global) {
  function moneyFromCents(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (global.Shopify && global.Shopify.currency && global.Shopify.currency.active) || 'USD',
      }).format(value);
    } catch (_) {
      return '$' + value.toFixed(2);
    }
  }

  function parseMemberConfig(root) {
    try {
      var el = root.querySelector('[data-sf-member-config]');
      if (!el) return { discounts: [] };
      var cfg = JSON.parse(el.textContent);
      return { discounts: Array.isArray(cfg.discounts) ? cfg.discounts : [] };
    } catch (_) {
      return { discounts: [] };
    }
  }

  function getDiscountCodeCookie() {
    try {
      var match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
      return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim().toUpperCase() : '';
    } catch (_) {
      return '';
    }
  }

  function matchedMemberDiscount(discounts, cart) {
    if (!discounts.length || !cart) return null;
    var applied = cart.discount_codes || [];
    var byCode = {};
    var lastApplicable = null;
    var lastAny = null;
    for (var i = 0; i < applied.length; i++) {
      var entry = applied[i];
      if (!entry || !entry.code) continue;
      var code = String(entry.code).trim().toUpperCase();
      for (var j = 0; j < discounts.length; j++) {
        if (discounts[j].code !== code) continue;
        byCode[code] = discounts[j];
        lastAny = discounts[j];
        if (entry.applicable !== false) lastApplicable = discounts[j];
      }
    }
    var cookieCode = getDiscountCodeCookie();
    if (cookieCode && byCode[cookieCode]) return byCode[cookieCode];
    return lastApplicable || lastAny;
  }

  function discountedCents(priceCents, compareCents, matched) {
    if (!matched) return priceCents;
    // Percent-off anchors on retail (compare_at) when the offer's `base` is
    // 'retail'; anchors on the customer's current sale price otherwise.
    // Cents-off always comes off the current price.
    var base = matched.base === 'retail' ? compareCents : priceCents;
    if (matched.pct > 0) return Math.max(0, Math.round(base * (1 - matched.pct / 100)));
    if (matched.cents > 0) return Math.max(0, priceCents - matched.cents);
    return priceCents;
  }

  function cartJsonUrl() {
    try {
      if (global.theme && global.theme.routes && global.theme.routes.cart_url) {
        return global.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
      }
    } catch (_) {}
    return '/cart.js';
  }

  function pullCart() {
    return fetch(cartJsonUrl())
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  global.MemberOffer = {
    moneyFromCents: moneyFromCents,
    parseMemberConfig: parseMemberConfig,
    getDiscountCodeCookie: getDiscountCodeCookie,
    matchedMemberDiscount: matchedMemberDiscount,
    discountedCents: discountedCents,
    cartJsonUrl: cartJsonUrl,
    pullCart: pullCart,
  };
})(window);
